export const USER_LOGOUT = "USER_LOGOUT";

export const userlogout = (payload) => ({
  type: USER_LOGOUT,
  value: payload,
});
